// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"organism-1-m__wrapper__VkzKA","group-1":"organism-1-m__group-1__1A842","group-2":"organism-1-m__group-2__3P57G"};